<div class="panelbar-wrapper">
	<app-wait [show]="showLoading" [message]="messageLoading"></app-wait>

	<kendo-panelbar *ngIf="model != null" expandMode="kendoPanelBarExpandMode.Single" >

		<kendo-panelbar-item *ngFor="let t of model" i18n-title [title]="t.title" [expanded]="false" [disabled]="toolBSrvc.getPanelDisabled(t)">
			<ng-template kendoPanelBarContent>
				<kendo-treeview [nodes]="t.items" textField="text">
					<ng-template kendoTreeViewNodeTemplate let-dataItem>
						<ng-template #template let-anchor>
							<div [style.backgroundImage]="'url(' + dataItem.thumbnail + ')'" class="thumbnail"></div>
						</ng-template>

						<span *ngIf="dataItem.type == 'EXTRA'">
							<button kendoButton [svgIcon]='projectService.svgIcons.plusOutlineIcon' (click)="addExtraOption(dataItem)"
								[disabled]="projectService.readOnly">
							</button>
							&nbsp;
						</span>

						<span kendoTooltip [tooltipTemplate]="template" filter="span">
							<span class="k-icon k-i-info"></span>
						</span>

						<span (click)="setCurrentTool(dataItem)" *ngIf="dataItem.type != 'EXTRA'">
							{{ dataItem.name }}
						</span>
						<span *ngIf="dataItem.type == 'EXTRA'">
							{{ dataItem.name }}
						</span>

					</ng-template>
				</kendo-treeview>
			</ng-template>
		</kendo-panelbar-item>

	</kendo-panelbar>
</div>
